<template>
  <div id="xzlj">
    <header>
      <div class="wrapper-logo">
          <img class="imglog" src="./img/logo@3x.png" alt="">
      </div>
    </header>
    <div class="wrapper">
      <img  class="dhqh" src="./img/pic@3x.png" alt="">
      <button class="downloadButton" @click="judgePhoneType()">立即下载</button>
    </div>
   <!-- <div id="tips" >
   
   </div> -->
   <van-overlay :show="show" id="tips" >
    <img src="./img/icon@2x.png" class="jt">
    <div class="sb">
      <img src="./img/①@3x.png"> 点击右上角的 ‘‘...’’
    </div>
    <div class="sb">
      <img src="./img/②@3.png"> 选择“在浏览器中打开”
    </div>
   </van-overlay>
  </div>
</template>
<script>
    /* eslint-disable */
  export default {
    name: 'xzlj',
    data () {
      return {
       show:true,
       iosUrl: 'itms-apps://itunes.apple.com/app/id1512070794',
       androidUrl:'https://f.cesfutures.com/qhweb/xzzx/file/CesFutures110.apk',
      }
    },
    created(){
      this.judgePhoneType()
    },
    methods: {
       isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
      }, 
      judgePhoneType(){
        //判断是否是微信扫码
       this.show = this.isWeixin() ? true : false
       var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? true : false
       var url = isiOS ? this.iosUrl : this.androidUrl
      // 微信扫码并且是ios手机  或者   浏览器扫码  
       if((this.isWeixin() && isiOS) || !this.isWeixin()) {
        window.location.href = url
       }
      }
    } 
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
 .wrapper-logo{
  display: flex;
  justify-content: left;
  height: 20%;
 }
 .imglog{
   height: 35%;
   width: 35%;
   margin-top: 15px;
   margin-left: 15px;
 }
 .wrapper{
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
 }
 .dhqh{
    height: 160px;
    margin-top: 60%;
 }
 .downloadButton{
    width: 140px;
    height: 40px;
    margin-top: 60px;
    background-color: #fda635;
    border: #fda635;
    border-radius: 6px;
    color: beige;
    font-size: 18px;
 }
 #tips{
  height: 100%;
  background: #000;
  opacity: 0.6;
  text-align: right;
}
.jt{
    margin-right: 25px;
    margin-top: 40px;
    width: 70px;
    height: 45px;
    margin-bottom: -20px;
}
.sb{
  color: #fff;
  text-align: left;
  font-size: 25px;
  margin-left: 12%;
  margin-bottom: 20px;
}
.sb img{
  width: 24px;
  position: relative;
  margin-right: 5px;   
}
</style> 
  



// WEBPACK FOOTER //
// xzlj.vue?13171e46